import styled from "styled-components";
export const Container = styled.div`
  width: 750px;
  height: 80vh;
  max-height: 80vh;
  overflow-y: auto;
  background-color: #f6f6f6;

  .cfCrUs {
    display: flex;
    width: 30rem;
    max-width: 35rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 0.3rem;
    font-size: 1.088rem;
    > div {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      > p:nth-child(3) {
        margin-top: 0.5rem;
      }
    }
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem;
  margin: 0;
  gap: 1rem;

  .jcSB {
    justify-content: space-between;
  }
`;
export const Card = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0.75rem;
  gap: 1rem;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.__white};
  box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, 0.08);

  .nt-gap {
    gap: 0;
  }
  > div {
    display: flex;
    gap: 0.5rem;
  }
  .x-60 {
    width: 60%;
  }
  .x-40 {
    width: 40%;
  }
  .phone {
    height: 2.5rem;
    margin-right: 0rem;
  }
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 1.1rem;
    font-weight: bold;
    > div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }
  .qsAtt {
    text-align: center;
    max-width: 6rem;
  }
`;
export const Tab = styled.div`
  display: flex;
  flex-direction: row;
  height: 2.75rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  > div {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100%;
    cursor: pointer;
    background-color: #f6f6f6;
    border-radius: 6px;
    transition: all 0.2s ease-in-out;
    
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      gap: 1rem;
    }
  }

  .select {
    background-color: ${({ theme }) => theme.colors.__blue[550]};
    color: ${({ theme }) => theme.colors.__white};
  }
`;
export const Input = styled.input`
  outline: none;
  border: none;
  width: 100%;
  height: 2.5rem;
  padding: 5px 12px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 6px;
  background-color: rgb(247 248 252);
  border: solid 1px #ececec;
  pointer-events: ${({ loading }) => (loading ? "none" : "auto")};
  color: ${({ theme }) => theme.colors.__gray[750]};
  &:disabled {
    opacity: 0.5;
    cursor: no-drop;
    color: #7e8c94;
    background-color: #eff2f7;
  }
`;
export const TabContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
  padding-right: 1rem;
  transition: all 0.1s ease; 

  > ul {
    padding: 0;
    margin: 0;

    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      margin-bottom: 1rem;
    }
  }

  li {
    list-style: none;
    border: 1px solid #d5d7d8;
  }

  .controls--groups {
    display: flex;
    margin-bottom: 1rem;
    > div {
      display: flex;
      flex: 1;
      justify-content: end;
      align-items: center;
      gap: 1rem;

      &:nth-child(2){
        margin-right: 1rem;
      }
    }
  }
`;
export const Actions = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;

  div:nth-child(1) {
    display: flex;
    gap: 0.5rem;
  }

  span {
    display: flex;
    height: 35px;
    width: 150px;
    justify-content: center;
    align-items: center;
    background: transparent;
    font-weight: 500;
    color: #1891fb;
    cursor: pointer;
    border-radius: 4px;
    border: solid 1px;
    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  .dsUs {
    color: rgb(251, 75, 75);
  }
  .imCUs {
    width: 170px;
  }
  button {
    display: flex;
    height: 35px;
    width: 150px;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    outline: none;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    font-weight: bolder;
    background-color: #1b72d6;
    color: ${({ theme }) => theme.colors.__white};
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  .btDi {
    opacity: 0.6;
    pointer-events: none;
  }
`;
export const LoadingProgress = styled.div`
  position: fixed;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: default;
  animation: ModalShow 0.1s ease-out;
  user-select: none;
  background-color: #00000040;
  > div {
    width: 400px;
    height: 400px;
    display: flex;
    border-radius: 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.__white};
    gap: 2rem;
    > div > img {
      max-width: 200px;
    }
    > div:nth-child(2) {
      max-width: 200px;
    }
    .loader {
      width: 50px;
      aspect-ratio: 1;
      display: grid;
      border: 4px solid #0000;
      border-radius: 50%;
      border-right-color: #25b09b;
      animation: l15 1s infinite linear;
    }
    .loader::before,
    .loader::after {
      content: "";
      grid-area: 1/1;
      margin: 2px;
      border: inherit;
      border-radius: 50%;
      animation: l15 2s infinite;
    }
    .loader::after {
      margin: 8px;
      animation-duration: 3s;
    }
    @keyframes l15 {
      100% {
        transform: rotate(1turn);
      }
    }
  }

  @keyframes ModalShow {
    0% {
      opacity: 0;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
`;
export const InfoUserCreateUpdate = styled.div`
  position: fixed;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: default;
  animation: ModalShow 0.1s ease-out;
  user-select: none;
  background-color: #00000040;
  @keyframes ModalShow {
    0% {
      opacity: 0;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  > div {
    display: flex;
    width: 390px;
    padding: 1rem;
    border-radius: 6px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.__white};
    gap: 0.5rem;
    > div {
      display: flex;
      width: 100%;
      gap: 0.75rem;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      > .trw {
        display: flex;
        width: 100%;
        height: 3rem;
        align-items: center;
        border-radius: 6px;
        border: solid 1px #ececec;
        > span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3rem;
          min-width: 3rem;
          height: 100%;
          background-color: #f1f1f1;
          color: #2f2e41;
          border-radius: 4px;
        }
        .trs {
          width: 2rem;
          background: transparent;
          cursor: pointer;
        }
        > input {
          outline: none;
          border: none;
          width: 100%;
          height: 2rem;
          text-align: center;
          background-color: transparent;
          padding-right: 3rem;
        }
      }
    }
    > button {
      outline: none;
      border: none;
      width: 200px;
      height: 2.5rem;
      cursor: pointer;
      border-radius: 4px;
      font-weight: bolder;
      background-color: #1d86ff;
      color: ${({ theme }) => theme.colors.__white};
      margin-top: 2rem;
    }
    .title {
      display: flex;
      justify-content: flex-start;
      align-items: end;
      font-size: 1.1rem;
      font-weight: bold;
      padding: 0.75rem;
    }
  }
`;
export const InfoUserContent = styled.div`
  display: flex;
  position: relative;
  div {
    position: absolute;
    z-index: 999;
    top: 2rem;
    right: 0;
    visibility: hidden;
    display: flex;
    width: 10rem;
    height: 3rem;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.__white};
    border: solid 1px #ecedef;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    > ul {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      > li {
        display: flex;
        width: 100%;
        justify-content: space-around;
        > span {
          font-size: 0.898rem;
        }
        > span:nth-child(2) {
          user-select: auto;
          cursor: text;
        }
      }
    }
  }
  .vis-- {
    visibility: visible;
  }
`;
export const MessageAlert = styled.div`
  max-width: 400px;
  > p {
    text-align: center;
    color: #ce3747;
  }
  span {
    color: #1d86ff;
  }
`;
export const Config = styled.div`
  display: flex;
  flex: 1;

  .ul-h {
    max-height: 0px;
    padding: 0;
    overflow: hidden;
  }

  .wrapConf {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .p-0 {
    padding: 0;
  }

  .gap-0 {
    gap: 0;
  }
`;
